import emprunteur from './emprunteur.png';
import emprunteur_plus from './emprunteur_plus.png';
import croisee from './croisee.png';
import homme_cle from './homme_cle.png';
import protection_personnelle from './protection_personnelle.png';
import protection_professionnels from './protection_professionnels.png';

const images = {
  'emprunteur.png': emprunteur,
  'emprunteur_plus.png': emprunteur_plus,
  'croisee.png': croisee,
  'homme_cle.png': homme_cle,
  'protection_personnelle.png': protection_personnelle,
  'protection_professionnels.png': protection_professionnels,
};

export default images;
